/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgTimerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M6.25 0a.75.75 0 0 0 0 1.5H7.5v1.55a5.98 5.98 0 0 0-3.4 1.586l-1.07-1.07a.75.75 0 0 0-1.06 1.06l1.07 1.07A6 6 0 0 0 2 9a6 6 0 1 0 12 0 6 6 0 0 0-1.04-3.304l1.07-1.07a.75.75 0 0 0-1.06-1.06l-1.07 1.07A6 6 0 0 0 9 3.05V1.5h1.25a.75.75 0 0 0 0-1.5zM8 4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M7.25 7a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0z"
    />
  </svg>
)
export default SvgTimerIcon
